import React from "react";

const Backend = ()=>{
    return(
        <div className="skills__content">
            <h3 className="skills__title">Backend development</h3>

            <div className="skills__box">
                <div className="skills__group">
                    <div className="skills__data">
                        {/* <i class='bx bx-badge-check' ></i>

                        <div> */}
                            <h3 className="skills__name">Node js</h3>
                            <span className="skills__level">Advance</span>
                            <img className="skills__img" src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png" alt="" />
                        {/* </div> */}
                    </div>

                    <div className="skills__data">
                        {/* <i class='bx bx-badge-check' ></i>

                        <div> */}
                            <h3 className="skills__name">NPM</h3>
                            <span className="skills__level">Advance</span>
                            <img className="skills__img" src="https://static-00.iconduck.com/assets.00/npm-icon-512x512-qtfdrf37.png" alt="" />
                        {/* </div> */}
                    </div>

                    <div className="skills__data">
                        {/* <i class='bx bx-badge-check' ></i>

                        <div> */}
                            <h3 className="skills__name">Express js</h3>
                            <span className="skills__level">Advance</span>
                            <img className="skills__img" src="https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png" alt="" />
                        {/* </div> */}
                    </div>
                </div>

                <div className="skills__group">
                    <div className="skills__data">
                        {/* <i class='bx bx-badge-check' ></i>

                        <div> */}
                            <h3 className="skills__name">Mongo DB</h3>
                            <span className="skills__level">Advance</span>
                            <img className="skills__img" src="https://pbs.twimg.com/profile_images/1452637606559326217/GFz_P-5e_400x400.png" alt="" />
                        {/* </div> */}
                    </div>

                    <div className="skills__data">
                        {/* <i class='bx bx-badge-check' ></i>

                        <div> */}
                            <h3 className="skills__name">Mongoose</h3>
                            <span className="skills__level">Advance</span>
                            <img className="skills__img" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/mongoose/mongoose.png" alt="" />
                        {/* </div> */}
                    </div>

                    <div className="skills__data">
                        {/* <i class='bx bx-badge-check' ></i>

                        <div> */}
                            <h3 className="skills__name">Git</h3>
                            <span className="skills__level">Advance</span>
                            <img className="skills__img" src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" alt="" />
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Backend;